import React from 'react'
import Section from './Section'
import markerIcon from '../scss/icons/marker.svg'
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"

class ContactSection extends Section {
    constructor(props) {
        super(props)
        this.state = this.state || {};
        this.state.activeIndex = 0;
    }

    prev() {
        if (this.state.activeIndex <= 0) {
            return;
        }

        this.setState({activeIndex: this.state.activeIndex-1})
    }

    next() {
        if (this.state.activeIndex >= 3) {
            return;
        }

        this.setState({activeIndex: this.state.activeIndex+1})
    }

    render() {
        const props = this.props;
        const activeIndex = this.state.activeIndex;
        const settings = props.settings || {}
        let children = props.children || {}

        const classNames = ['section', 'contact-section']
        classNames.push("on-screen")

        const ContactMap = withScriptjs(withGoogleMap((props) =>
          <GoogleMap
            defaultZoom={props.defaultZoom}
            defaultCenter={props.defaultCenter}
            options={{
                disableDefaultUI: true
            }}
         >
            <Marker position={props.defaultCenter} icon={markerIcon} animation="drop" onClick={() => {window.open(props.routeUrl, "_blank")}} clickable={true} />
          </GoogleMap>
        ))

        return (
            <section className={classNames.join(' ')}>
                <ContactMap
                    defaultZoom={17}
                    defaultCenter={{lat:51.5482771, lng:6.5504035}}
                    routeUrl="https://www.google.de/maps/dir//Fahrsicherheitscentrum+Rheinberg,+Heydecker+Str.+145,+47495+Rheinberg/@51.3971142,6.3887004,10z"
                    mapElement={<div style={{ height: `100%` }} />}
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div style={{ height: `800px` }} />}
                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyA_1t5M5Uz74CvbAQN1eRAycFVKWafMa4M&v=3.exp&libraries=geometry,drawing"
                />
            </section>  
        )
    }
}

export default ContactSection


// WEBPACK FOOTER //
// ./src/components/ContactSection.js